
























import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { DrivewealthAccountManagementType } from "@/shared/types";
import AdvisoryFunds from "@/shared/components/investments/drivewealth/AdvisoryFunds.vue";
import OpenBrokerageSearch from "@/shared/components/investments/drivewealth/OpenBrokerageSearch.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    AdvisoryFunds,
    OpenBrokerageSearch,
    DrivewealthNavigation,
  }
})
export default class AvailableInvestmentsPage extends Vue {
  @Prop({required: false}) username: string;
  @Prop({required: false}) partnerId: number;
  @Prop({required: false}) accountId: number;

  drivewealthStore = useDrivewealthStore();

  mounted (): void {
    this.drivewealthStore.getAccountSummaryV2(
        { username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId });
  }

  get showOpenBrokerage () {
    const accountSummary = this.drivewealthStore.accountSummaryById(this.accountId);
    return accountSummary && accountSummary.accountManagementType === DrivewealthAccountManagementType.OpenBrokerage;
  }
}
